import { useId } from 'react';
import { IconPropsType } from '..';

export const HeartFilledColoredIcon = ({ fill, ...props }: IconPropsType) => {
  const id = useId();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6438 9.67264L9.00177 15.9201L2.34223 9.66174L2.33055 9.65083L2.02678 9.3619L2.03846 9.351C0.426155 7.53018 0.525463 4.8153 2.34223 3.10351C4.159 1.39172 7.0664 2.24914 9 3.77012C10.9394 2.2764 13.8445 1.40262 15.6555 3.10351C17.4722 4.8153 17.5774 7.52472 15.9592 9.351L15.9709 9.3619L15.6671 9.65083L15.6438 9.67264Z"
        fill={`url(#paint0_linear_25513_32258${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_25513_32258${id}`}
          x1="1.49998"
          y1="12"
          x2="13.5"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E3E4" />
          <stop
            offset="0.624312"
            stopColor="#E2E3E4"
          />
          <stop
            offset="0.625651"
            stopColor="currentColor"
          />
          <stop
            offset="1"
            stopColor="currentColor"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
